<template>
  <app-page-container title="گزارش تماس های اخیر ورودی">
    <template v-slot:header>
      <v-col cols="4">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3 mr-n16"></v-text-field>
      </v-col>
      <v-col cols="2" class="mr-n13">
        <v-btn rounded small class="darkColor mt-3 mr-n3" dark icon fab @click="getListOfRecentCallsFor115Report">
          <v-icon class="">mdi-refresh mdi-18px</v-icon>
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main mx-2">
        <v-col cols="12">
          <v-card elevation="0" class="body-card card-width">
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <template>
                    <v-data-table fixed-header @click:row="triggerOnEachItem" :headers="callReport115TableHeaders"
                      :items="callReport115List" :search="searchTitle" :items-per-page="callReport115List.length"
                      height="78vh" :hide-default-footer="true" multi-sort class="elevation-0 tt">
                      <template v-slot:[`item.rowNumber`]="{ index }">
                        <div>
                          {{ index + 1 }}
                        </div>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <div class="btnCallBox">
                          <v-menu rounded="lg">
                            <template v-slot:activator="{ on: menu, attrs }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on: tooltip }">
                                  <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer" v-bind="attrs"
                                    v-on="{ ...tooltip, ...menu }">
                                    mdi-phone
                                  </v-icon>
                                </template>
                                <span>تماس</span>
                              </v-tooltip>
                            </template>
                            <v-list>
                              <v-list-item dense v-for="(i, index) in item?.patiantPhoneNumbers" :key="index"
                                @click="callToPatient(i, false, item.myMissionId)">
                                <v-list-item-content>
                                  <v-list-item-title>{{ i }}</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer" v-bind="attrs"
                                @click="playAudioMissionFunction(item.id)" v-on="on">
                                mdi-play-circle
                              </v-icon>
                            </template>
                            <span>پخش صوت</span>
                          </v-tooltip>
                        </div>
                      </template>
                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <!--audio ***********************************************-->
      <!-- <v-dialog v-model="player" width="400px" style="overflow-x: hidden" :key="recordFile">
        <v-card width="400px">
          <v-row justify="center" style="overflow-x: hidden" no-gutters>
            <v-col cols="10" style="text-align: center" class="mt-4">
              <audio controls oncontextmenu="return false;" controlsList="nodownload" cors-anonym="true" autoplay
                :src="recordFile" ref="audioFile"></audio>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="no-letter-space" @click="stopMusic()">بستن F</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
        :snakIcon="snakIcon"></alert-component>
    </template>
  </app-page-container>
</template>
<script>
import AlertComponent from '@/components/AlertComponent.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import MissionMixin from '@/Mixins/Mission/MissionMixin.js';
import CallReport115Helper from '@/Helpers/Report/115/CallReport115Helper.js';
import CallMixin from '@/Mixins/Call/CallMixin.js';
import CopyTextHelper from '@/Helpers/CopyText.helper';
import AppPageContainer from '@/components/app/PageContainer.vue';

export default {
  name: 'CallReport115',
  title: 'گزارش تماس های اخیر ورودی 115',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    AppPageContainer,
  },
  mixins: [
    ShearedMixin,
    MissionMixin,
    CallReport115Helper,
    snackBar,
    ShearedHelper,
    CallMixin,
    CopyTextHelper,
  ],
  created() {
    this.$root.$refs.CallReport115 = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      let userPermissions = this.$store.state.userModule.user.permissions;
      for (const item of userPermissions) {
        if (item.id == 1) {
          this.listenVoicePermission = true;
        }
        if (item.id == 2) {
          this.seePhoneNumberPermission = true;
        }
      }
      this.getListOfRecentCallsFor115Report();
    },
  },
};
</script>
<style scoped>
.btnCallBox {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}



>>>table tbody tr td:nth-child(12),
>>>table thead tr th:nth-child(12) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0 !important;
  z-index: 99 !important;
  background: white !important;
}

table>thead>tr>th:nth-child(12) {
  z-index: 100 !important;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
